import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  SET_NEW_PASSWORD,
  SET_NEW_PASSWORD_AFTER_EXPIRE,
  SET_NEW_PASSWORD_SUCCESS,
  RESET_FORGET_PASSWORD,
} from "./actionTypes";

const initialState = {
  message: null,
  error: null,
  loading: false,
  success: false,
};

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case RESET_FORGET_PASSWORD:
      state = initialState;
      break;
    case FORGET_PASSWORD:
      state = {
        loading: true,
        success: false,
      };
      break;
    case FORGET_PASSWORD_SUCCESS:
      state = {
        loading: false,
        success: true,
        message: action.payload,
      };
      break;
    case SET_NEW_PASSWORD:
      state = {
        loading: true,
        success: false,
      };
      break;
    case SET_NEW_PASSWORD_AFTER_EXPIRE:
      state = {
        loading: true,
        success: false,
      };
      break;
    case SET_NEW_PASSWORD_SUCCESS:
      state = {
        loading: false,
        success: true,
        message: action.payload,
      };
      break;
    case FORGET_PASSWORD_ERROR:
      state = {
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default forgetPassword;
